document.addEventListener('DOMContentLoaded', function () {

    /* =========================
       OPACED SWIPER
    ========================= */
    const swiperOpaced = new Swiper('.swiper-container.opaced', {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-flipbox-button-next',
            prevEl: '.swiper-flipbox-button-prev',
        },
        breakpoints: {
            480: { slidesPerView: 1.2, spaceBetween: 10 },
            768: { slidesPerView: 2.2, spaceBetween: 20 },
            1024: { slidesPerView: 2.2, spaceBetween: 30 },
            1440: { slidesPerView: 3, spaceBetween: 30 }
        },
        observer: true,
        observeParents: true,
        on: {
            init(swiper) {
                updateOpacity(swiper);
                updateNav(swiper);
            },
            slideChange(swiper) {
                updateOpacity(swiper);
                updateNav(swiper);
            },
            resize(swiper) {
                updateOpacity(swiper);
                updateNav(swiper);
            },
            transitionEnd(swiper) {
                updateOpacity(swiper);
            }
        }
    });

    function updateOpacity(swiper) {
        if (!swiper) return;

        // 🔥 sichere Container-Ermittlung
        let container = swiper.el;

        // Falls kein echtes DOM-Element → fallback auf selector
        if (!(container instanceof HTMLElement)) {
            container = document.querySelector('.swiper-container.opaced');
        }

        if (!container) return;

        const slides = swiper.slides;
        if (!slides || !slides.length) return;

        const cRect = container.getBoundingClientRect();

        slides.forEach(slide => {
            if (!(slide instanceof HTMLElement)) return;

            const r = slide.getBoundingClientRect();

            const visibleWidth = Math.max(
                0,
                Math.min(r.right, cRect.right) - Math.max(r.left, cRect.left)
            );

            slide.style.opacity = (visibleWidth >= r.width - 1) ? "1" : "0.5";
        });
    }

    /* =========================
       DEFAULT SWIPER
    ========================= */
    const swiperDefault = new Swiper('.swiper-container:not(.opaced)', {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-flipbox-button-next',
            prevEl: '.swiper-flipbox-button-prev',
        },
        breakpoints: {
            480: { slidesPerView: 1.2, spaceBetween: 10 },
            768: { slidesPerView: 2.2, spaceBetween: 20 },
            1024: { slidesPerView: 2.2, spaceBetween: 30 },
            1440: { slidesPerView: 3, spaceBetween: 30 }
        },
        observer: true,
        observeParents: true,
        on: {
            init: updateNav,
            slideChange: updateNav,
            resize: updateNav
        }
    });

    /* =========================
       CONTAINED
    ========================= */
    const swiperContained = new Swiper('.contained', {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-flipbox-button-next',
            prevEl: '.swiper-flipbox-button-prev',
        },
        breakpoints: {
            480: { slidesPerView: 1.2, spaceBetween: 10 },
            768: { slidesPerView: 2, spaceBetween: 20 },
            1024: { slidesPerView: 4, spaceBetween: 30 },
            1440: { slidesPerView: 4, spaceBetween: 30 }
        },
        on: {
            init: updateNav,
            slideChange: updateNav
        }
    });

    /* =========================
       IMPRESSIONS
    ========================= */
    const swiperImpressions = new Swiper('.impressions-wrapper', {
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            0: { slidesPerView: 1, spaceBetween: 10 },
            768: { slidesPerView: 2, spaceBetween: 30 },
            1024: { slidesPerView: 3, spaceBetween: 50 },
            1440: { slidesPerView: 3, spaceBetween: 30 }
        },
        on: {
            init: updateActiveSlide,
            slideChange: updateActiveSlide,
            resize: updateActiveSlide
        }
    });

    /* =========================
       SPECIAL CAROUSEL
    ========================= */
    const swiperSpecial = new Swiper('.carousel-special .swiper-container', {
        slidesPerView: 3,
        loop: true,
        loopedSlides: 4,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.impression-arrow-next',
            prevEl: '.impression-arrow-prev',
        },
        breakpoints: {
            480: { slidesPerView: 1, spaceBetween: 10 },
            768: { slidesPerView: 2, spaceBetween: 30 },
            1024: { slidesPerView: 3, spaceBetween: 50 }
        },
        on: {
            init(swiper) {
                updateNav(swiper);
                updateActiveSlide(swiper);
                updateSlideCount(swiper);
            },
            slideChange(swiper) {
                updateNav(swiper);
                updateActiveSlide(swiper);
                updateSlideCount(swiper);
            },
            resize(swiper) {
                updateActiveSlide(swiper);
                updateSlideCount(swiper);
            }
        }
    });

    /* =========================
       GLOBAL HELPERS
    ========================= */

    function updateNav(swiper) {
        const prev = document.querySelector(swiper.params.navigation?.prevEl);
        const next = document.querySelector(swiper.params.navigation?.nextEl);

        if (!prev || !next) return;

        if (swiper.params.loop) {
            prev.style.display = '';
            next.style.display = '';
            return;
        }

        prev.style.display = swiper.activeIndex === 0 ? 'none' : '';
        next.style.display = swiper.isEnd ? 'none' : '';
    }

    function updateActiveSlide(swiper) {
        const slides = swiper.slides;
        const perView = swiper.params.slidesPerView;

        let middle = swiper.activeIndex;

        if (typeof perView === 'number' && perView > 1) {
            middle += Math.floor(perView / 2);
        }

        slides.forEach((s, i) => {
            s.classList.toggle('active-slide', i === middle);
        });
    }

    function updateSlideCount(swiper) {
        const realSlides = Array.from(swiper.slides)
            .filter(s => !s.classList.contains('swiper-slide-duplicate'));
        const total = realSlides.length;
        const current = swiper.realIndex + 1;

        const currentEl = document.querySelector('.current-slide');
        const totalEl = document.querySelector('.total-slides');


        if (currentEl) currentEl.textContent = current;
        if (totalEl) totalEl.textContent = total;
    }

    /* =========================
       GLOBAL EVENTS
    ========================= */

    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => updateOpacity(swiperOpaced), 50);
    });

    let scrollTimeout;
    window.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => updateOpacity(swiperOpaced), 50);
    });

});